import { h } from 'preact'; /** @jsx h */

import './CTABlock.scss';

const CTABlock = ({
    anchor,
    color = 'secondary',
    title,
    innerTitle,
    bulletPoints,
    buttonText,
    link,
    orientation = 'left',
    imageSrc,
    divider = false,
    children,
    appleGoogleStore = false
}) => {
    const buttonTextParts = buttonText?.split(' - ');
    const isMobile = window.innerWidth < 768;
    return (
        <div className={`cta-block-wrapper color-${color}`} id={anchor}>
            {divider && <div className="divider" />}
            <div className="title-container">
                <h2 className="title" dangerouslySetInnerHTML={{ __html: title }} />
            </div>
            <div className={`help-1-1-block orientation-${orientation}`}>
                <div
                    className="help-image-container"
                    style={{
                        backgroundImage: `url(${imageSrc})`
                    }}
                />
                <div className="help-text-container">
                    <div className="help-text-content">
                        <h3 className="help-title">{innerTitle}</h3>
                        {children && <div className="help-text">{children}</div>}
                        {bulletPoints && bulletPoints.length > 0 && (
                            <ul className="help-list">
                                {bulletPoints.map((bullet, index) => (
                                    <li className="help-list-item" key={index}>
                                        {bullet}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    {appleGoogleStore ? (
                        <div className="store-btn-container">
                            <a
                                className="store-link-btn google-play"
                                href="https://play.google.com/store/apps/details?id=com.favouritesystems.android.emergencyapp.nla113&hl=no&pli=1"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    className="store-link-icon"
                                    src="https://norskluftambulanse.no/wp-content/uploads/2024/11/google-play.png"
                                    loading="lazy"
                                />
                            </a>
                            <a
                                className="store-link-btn app-store"
                                href="https://apps.apple.com/no/app/hjelp-113/id363739748?l=nb"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    className="store-link-icon"
                                    src="https://norskluftambulanse.no/wp-content/uploads/2024/11/App-Store-Badge.png"
                                    loading="lazy"
                                />
                            </a>
                        </div>
                    ) : (
                        <div className="btn-container">
                            <a className="link-btn" href={link}>
                                <span>
                                    {isMobile && buttonTextParts.length > 1 ? (
                                        <span className="cta-link-mobile-text">
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: buttonTextParts[0]
                                                }}
                                            />
                                        </span>
                                    ) : (
                                        <span
                                            className="link-text"
                                            dangerouslySetInnerHTML={{
                                                __html: buttonText
                                            }}
                                        />
                                    )}
                                </span>
                                <span className="material-symbols-outlined">arrow_forward</span>
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CTABlock;
